module.exports = __webpack_public_path__ + "media/warranty-claim/release-tape-54ae5c70.png";